import React from 'react';
import PlaceholderPage from './PlaceholderPage';
import placeholderStyles from './PlaceholderPage.module.css';
import { useContentCatalog } from '../../utils/contentCatalog';

const CommunityPage = () => {
  const { catalog } = useContentCatalog();
  const page = catalog?.pages?.community;

  return (
    <PlaceholderPage
      className={placeholderStyles.quickRichuelType}
      title={page?.title || 'Community'}
      subtitle={page?.subtitle || ''}
      heroEyebrow={page?.eyebrow || ''}
      description={page?.description || ''}
      icon="🤝"
      highlights={page?.highlights || []}
    />
  );
};

export default CommunityPage;
